import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from 'app/components/ui/toast';
import { useToast } from 'app/components/ui/use-toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider duration={4000}>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className={`flex flex-col ${props.variant === 'emailsuccess' || props.variant === 'signinsuccess' ? 'justify-center items-center mx-auto' : 'gap-1'}`}>
              <div className={`${props.variant === 'emailsuccess' || props.variant === 'signinsuccess' ? 'flex flex-col items-center gap-2 mb-4' : ''}`}>
                {title && <ToastTitle variant={props.variant as 'default' | 'destructive' | 'emailsuccess' | 'signinsuccess'}>{title}</ToastTitle>}
                {props.variant === 'emailsuccess' && (
                  <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" viewBox="0 0 49 48" fill="none">
                    <g clipPath="url(#clip0_6203_109766)">
                      <path d="M38.5 20C44.022 20 48.5 15.522 48.5 10C48.5 4.478 44.022 0 38.5 0C32.978 0 28.5 4.478 28.5 10C28.5 15.522 32.978 20 38.5 20ZM34.5 8H36.5V6C36.5 4.896 37.396 4 38.5 4C39.604 4 40.5 4.896 40.5 6V8H42.5C43.604 8 44.5 8.896 44.5 10C44.5 11.104 43.604 12 42.5 12H40.5V14C40.5 15.104 39.604 16 38.5 16C37.396 16 36.5 15.104 36.5 14V12H34.5C33.396 12 32.5 11.104 32.5 10C32.5 8.896 33.396 8 34.5 8ZM20.256 29.092L1.988 10.822C3.746 7.944 6.888 6 10.5 6H25.088C24.71 7.268 24.5 8.61 24.5 10C24.5 16.318 28.688 21.656 34.438 23.396L28.744 29.092C27.574 30.26 26.038 30.844 24.5 30.844C22.964 30.844 21.426 30.26 20.256 29.092ZM48.468 19.824L48.5 38C48.5 43.514 44.014 48 38.5 48H10.5C4.986 48 0.5 43.514 0.5 38V16C0.5 15.686 0.564 15.39 0.592 15.084L17.428 31.92C19.378 33.87 21.938 34.844 24.5 34.844C27.062 34.844 29.622 33.87 31.572 31.92L39.544 23.948C43.028 23.69 46.16 22.168 48.47 19.824H48.468Z" fill="#55B494"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_6203_109766">
                        <rect width="48" height="48" fill="white" transform="translate(0.5)"/>
                      </clipPath>
                    </defs>
                  </svg>
                )}
                {props.variant === 'signinsuccess' && (
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <g clipPath="url(#clip0_6203_109971)">
                      <path d="M24 0C10.766 0 0 10.766 0 24C0 37.234 10.766 48 24 48C37.234 48 48 37.234 48 24C48 10.766 37.234 0 24 0ZM36.4 21.024L27.548 29.714C25.982 31.25 23.966 32.016 21.948 32.016C19.952 32.016 17.956 31.264 16.396 29.758L12.598 26.024C11.81 25.25 11.8 23.984 12.574 23.196C13.346 22.406 14.616 22.396 15.402 23.172L19.188 26.894C20.74 28.394 23.19 28.386 24.75 26.858L33.6 18.17C34.386 17.394 35.648 17.408 36.428 18.196C37.202 18.984 37.19 20.25 36.4 21.024Z" fill="#55B494"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_6203_109971">
                        <rect width="48" height="48" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                )}
              </div>
              {description && (
                <ToastDescription
                  variant={props.variant as 'default' | 'destructive' | 'emailsuccess' | 'signinsuccess'}
                  className={`${props.variant === 'emailsuccess' ? 'text-center' : ''}`}
                >
                  {description}
                </ToastDescription>
              )}
              {props.variant === 'emailsuccess' ? (
                <div className='flex items-center gap-2.5 mt-4'>
                  <span className='font-montserrat text-[#4D5358] text-xs font-semibold leading-normal'>
                    Didn’t get a link?
                  </span>
                  {action}
                </div>
              ) : props.variant === 'signinsuccess' ? (
                  <div className={action ? 'mt-6' : ''}>
                    {action}
                  </div>
              ) :
                action
              }
            </div>
            <ToastClose variant={toasts[0]?.variant as 'default' | 'destructive' | 'emailsuccess' | 'signinsuccess' | undefined} />
          </Toast>
        );
      })}
      <ToastViewport variant={toasts[0]?.variant as 'default' | 'destructive' | 'emailsuccess' | 'signinsuccess' | undefined} />
    </ToastProvider>
  );
}
